import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=3d724f6c&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=3d724f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d724f6c",
  null
  
)

export default component.exports